"use client"

import { Building2 } from "lucide-react"
import { useCurrentTenantQuery } from "@/hooks/queries/current-tenant"
import { Badge } from "@/components/ui/badge"
import { useTranslations } from "next-intl"


export function TenantInfo() {
  const tCommonUi = useTranslations("Common")
  const tUi = useTranslations("Shell.TenantInfo")

  const { tenant, isLoading } = useCurrentTenantQuery()

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-sm text-gray-500">
        <Building2 className="w-4 h-4" />
        <span><span key={tCommonUi("loading")}>{tCommonUi("loading")}</span></span>
      </div>
    )
  }

  if (!tenant) {
    return null
  }

  return (
    <div className="flex min-w-0 items-center gap-2">
      {tenant.logo_url ? (
        // eslint-disable-next-line @next/next/no-img-element -- tenant logos come from arbitrary hosts
        <img src={tenant.logo_url} alt={tenant.name} className="w-6 h-6 shrink-0 rounded object-cover" />
      ) : (
        <div className="w-6 h-6 shrink-0 bg-gray-200 rounded flex items-center justify-center">
          <Building2 className="w-4 h-4 text-gray-500" />
        </div>
      )}
      <span className="truncate text-sm font-medium text-gray-700">{tenant.name}</span>
      {!tenant.is_active && (
        <Badge variant="destructive" className="text-xs">
          <span key={tUi("inactive")}>{tUi("inactive")}</span></Badge>
      )}
    </div>
  )
}
